import { connect } from 'react-redux';

import { getAuth } from 'common/redux/auth/selectors';
import { IReduxState } from 'common/redux/createStore';
import {
  getCartCoupons,
  getCartLineItems,
  getCartShippingMethods,
  getCartTotalItems,
} from 'common/redux/wooCommerce/cart/selectors';
import { getPaymentGateways } from 'common/redux/wooCommerce/selectors';

import withStripe from '../../../hoc/withStripe';
import PaymentRequestButton, {
  IPaymentRequestButtonProps,
  IStorePaymentRequestButtonProps,
} from './PaymentRequestButton';

const mapStateToProps = (
  state: IReduxState
): IStorePaymentRequestButtonProps => ({
  totalItems: getCartTotalItems(state),
  cartLineItems: getCartLineItems(state),
  shippingMethods: getCartShippingMethods(state),
  coupons: getCartCoupons(state),
  paymentGateway: getPaymentGateways(state)[0],
  user: getAuth(state),
});

export default connect<
  IStorePaymentRequestButtonProps,
  never,
  IPaymentRequestButtonProps
>(mapStateToProps)(withStripe(PaymentRequestButton));
